import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PpcOverTimeAsins from './components/Page';

const PpcOverTimeAsinsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">PPC Over Time Asins</h3>
      </Col>
    </Row>
    <Row>
      <PpcOverTimeAsins />
    </Row>
  </Container>
);

export default PpcOverTimeAsinsPage;
